export const IMAGES_HINTS = {
  FAVICON: '.png and .ico files only (5MB max file size). Favicon should be square. The recommended image size is 180px x 180px',
  LOGO: '.png & .jpg files only (24MB max file size). Logo should be square or horizontal proportioned with 5:3 to get the best result.',
  HERO_IMAGE: 'The recommended image size is 1920px x 806px',
  HERO_IMAGE_VIDEO: '.png, .jpg, or .mp4 files only (50MB max file size). The recommended image size is 1920px x 806px. Videos should be 1080p',
  ABOUT_IMAGES: 'The recommended image size for each image is 800px x 1040px',
  PERSONA_IMAGE: 'The recommended image size is 800px x 1000px',
};
